import { Button, Modal, Alert } from 'react-bootstrap';
import { ReactNode } from 'react';

interface ConfirmModalProps {
  show: boolean;
  title: string;
  message: ReactNode;
  error?: string | null;
  handleOK: () => void;
  handleCancel: () => void;
}

export const ConfirmModal = ({
  show,
  title,
  error,
  message,
  handleOK,
  handleCancel,
}: ConfirmModalProps) => {
  return (
    <Modal show={show}>
      <Modal.Header className="border-bottom-0">
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="fs-5">
        {error && <Alert variant="danger">{error}</Alert>}
        {message}
      </Modal.Body>
      <Modal.Footer className="border-top-0 d-flex justify-content-between">
        <Button variant="secondary" type="button" onClick={handleCancel} className="px-4">
          キャンセル
        </Button>
        <Button variant="success" type="button" onClick={handleOK} className="px-4">
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
